import { merge } from 'lodash';
import * as React from 'react';
import ToggleButton, { ToggleButtonProps } from 'react-toggle-button';
import getClientEnvironment from '../getClientEnvironment';

const config = getClientEnvironment();

const DEFAULT_WIDTH = 42;
const DEFAULT_HEIGHT = 20;

/** Default toggle button props to match the application styles */
const defaultProps: Partial<ToggleButtonProps> = {
    activeLabel: 'on',
    activeLabelStyle: {
        // Hack to hide the label without messing up the formatting
        visibility: 'hidden'
    },
    colors: {
        active: {
            base: config.PRIMARY_COLOR
        },
        activeThumb: {
            base: 'white'
        },
        inactive: {
            base: '#8a9299',
            hover: '#8a9299'
        },
        inactiveThumb: {
            base: '#fafafa'
        }
    },
    containerStyle: {
        display: 'inline-block',
        marginTop: '5px'
    },
    inactiveLabel: ''
};

/**
 * Helper to calculate the styles required for different widths and heights
 * without hard-coding them
 */
const calculateSizes = ({
    width,
    height
}: {
    width: number;
    height: number;
}): Partial<ToggleButtonProps> => {
    const borderWidth = 1;
    const innerHeight = height - borderWidth * 2;
    const innerWidth = width - borderWidth * 2;

    return {
        activeLabelStyle: {
            left: 2,
            width: innerWidth / 2
        },
        containerStyle: {
            height,
            width
        },
        inactiveLabelStyle: { width: innerWidth / 2 },
        thumbAnimateRange: [
            borderWidth,
            borderWidth + (innerWidth - innerHeight)
        ],
        thumbStyle: {
            height: innerHeight,
            width: innerHeight
        },
        trackStyle: {
            borderRadius: height / 2,
            height,
            width
        }
    };
};

/**
 *  Toggle button styled to match the application
 *  Wraps a react-toggle-button button
 */
export default ({
    width = DEFAULT_WIDTH,
    height = DEFAULT_HEIGHT,
    ...props
}: ToggleButtonProps & { width?: number; height?: number }) => {
    let mergedProps = merge(defaultProps, props);
    if (width && height) {
        mergedProps = merge(mergedProps, calculateSizes({ width, height }));
    }

    return <ToggleButton {...mergedProps} />;
};



// WEBPACK FOOTER //
// ./src/client/components/ToggleButton.tsx